
import * as type from './types';

export function deleteBid(data) {
    return {
        type: type.DELETE_BID_REQUESTED,
        data: data,
    }
};